
namespace RioERP.Masters {
    export class WhatsAppMessagesColumns {
        static columnsKey = 'Masters.WhatsAppMessages';
    }
}